import type { WorkShiftGroup } from "@senciamatch/shared/models/workShiftGroup";
import { useState } from "react";
import { HistoryModal } from "./HistoryModal";

interface Props {
  displayMode: "staff" | "building";
  setDisplayMode: (displayMode: "staff" | "building") => void;
  workShiftGroup: WorkShiftGroup;
  onPrint: () => void;
}

export const Header = (props: Props) => {
  const { displayMode, setDisplayMode, workShiftGroup, onPrint } = props;
  const [showHistoryModal, setShowHistoryModal] = useState(false);

  return (
    <>
      <div className="bg-gray-100 h-20 flex items-center gap-4 px-8 justify-between">
        <div className="flex items-center gap-4">
          <label className="text-sm flex items-center gap-2">
            <input
              type="radio"
              className="hidden"
              checked={displayMode === "building"}
              onChange={() => {
                setDisplayMode("building");
              }}
            />
            {displayMode === "building" ? (
              <img src="/icons/radio_button_checked.svg" alt="checked" />
            ) : (
              <img src="/icons/radio_button_unchecked.svg" alt="unchecked" />
            )}
            物件別
          </label>
          <label className="text-sm flex items-center gap-2">
            <input
              type="radio"
              className="hidden"
              checked={displayMode === "staff"}
              onChange={() => {
                setDisplayMode("staff");
              }}
            />
            {displayMode === "staff" ? (
              <img src="/icons/radio_button_checked.svg" alt="checked" />
            ) : (
              <img src="/icons/radio_button_unchecked.svg" alt="unchecked" />
            )}
            従業員別
          </label>
        </div>

        <div className="flex items-center gap-4">
          <button
            type="button"
            className="bg-gray-600 text-white px-4 py-2 rounded-md w-40"
            onClick={() => setShowHistoryModal(true)}
          >
            履歴
          </button>
          <button type="button" className="bg-black text-white px-4 py-2 rounded-md w-40" onClick={() => onPrint()}>
            印刷
          </button>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <p className="text-xl font-bold ml-8 mt-8">{workShiftGroup.name}</p>
        <p className="text-sm mr-8 mt-8">
          全日：Ａ、午前：Ｂ、深夜：Ｅ、未定：Ｇ、予約なし：―、勤務不可：×、全日（深夜可）：ＡＥ、勤務可能：○
        </p>
      </div>

      {showHistoryModal && <HistoryModal workShiftGroup={workShiftGroup} onClose={() => setShowHistoryModal(false)} />}
    </>
  );
};
